export default __webpack_public_path__ + "static/media/icon_twitter.79e6695c.svg";